import { IconProps } from '@veneer/core';
import { ComponentType } from 'react';

export type IconType = ComponentType<IconProps>;

export interface IPlanInfo {
  name: string;
  pages: string;
  additionalPages: string;
  rolloverPages: string;
  basePrice: string;
  priceWithPaper: string;
  sku: string;
}

export interface IPrintPlan {
  planModelPurpose: string;
  modelName: string;
  sku: string;
  planInfos: IPlanInfo[];
}

export interface IModalInkFeaturesList {
  icon: IconType;
  text: string;
}

export interface ModalInkPlansProps {
  id?: string;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  features: IModalInkFeaturesList[];
  printPlansTitle: string;
  paperToggleLabel: string;
  paperAddOnLabel: string;
  showPaper?: boolean;
  printPlans: IPrintPlan[];
  initialModelPurpose?: string;
  onAnalytics?: (data: ModalInkPlansAnalyticsPayload) => void;
}

export enum ModalInkPlansAnalyticsEvent {
  PLAN_SELECTED = 'PLAN_SELECTED',
  PAPER_TOGGLE = 'PAPER_TOGGLE',
}

export type ModalInkPlansAnalyticsPayload = {
  eventName: ModalInkPlansAnalyticsEvent;
  payload: unknown;
};
